import { Component, inject, OnInit, signal } from '@angular/core';
import { PublicControllerService } from 'src/app/api-client';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss'],
})
export class PrivacyPolicyComponent implements OnInit {
  private _public = inject(PublicControllerService);

  public privacy = signal<any>(null);

  constructor(private sanitized: DomSanitizer) {}

  ngOnInit(): void {
    this.getPrivacyPolicy();
  }

  private getPrivacyPolicy() {
    this._public.getPrivacyPolicyForWeb().subscribe({
      next: (value) => {
        let formattedString = value
          .replaceAll('\\n', ' ')
          .replaceAll('<hr>', ' ');
        this.privacy.update(() =>
          this.sanitized.bypassSecurityTrustHtml(formattedString)
        );
      },
    });
  }
}
